import React from 'react';
import * as PropTypes from 'prop-types';
import ReactRating from 'react-rating';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStartRegular } from '@fortawesome/pro-regular-svg-icons';

/**
 * Convert rating from scale of 0-100 into 1-5 rating stars
 *
 * @param {number} rating
 * @return {number}
 */
export const convertRating = (rating) => {
  const converted = rating / 20;
  if (converted.toString().includes('.')) {
    return parseFloat(converted.toFixed(1));
  }
  return converted;
};

export const VideoRating = ({ averageRating = 0, userRating = 0, onRate, readonly, showStats = true }) => {
  const fullSymbol = <FontAwesomeIcon icon={faStar} data-e2e="fullSymbol" />;
  const emptySymbol = <FontAwesomeIcon icon={faStartRegular} data-e2e="emptySymbol" />;

  //a class to determine if the rating component is active and allows to rate a video
  const activeClass = !readonly ? ' ct-rating--active' : '';

  return (
    <div data-e2e="rating" className={`ct-rating${activeClass}`}>
      {showStats && (
        <div className="rate-number" data-e2e="rating-number">
          {readonly ? <b>{convertRating(userRating)}</b> : <b>{convertRating(averageRating)}</b>} / 5
        </div>
      )}

      <ReactRating
        start={0}
        stop={5}
        step={1}
        initialRating={convertRating(userRating)}
        emptySymbol={emptySymbol}
        fullSymbol={fullSymbol}
        onChange={onRate}
        readonly={readonly}
      />
    </div>
  );
};

VideoRating.propTypes = {
  averageRating: PropTypes.number,
  userRating: PropTypes.number,
  onRate: PropTypes.func,
  readonly: PropTypes.bool,
  showStats: PropTypes.bool,
};